import { useSelector } from 'react-redux';
import { selectExperiments } from '../selectors/experiments';
import { selectPageSection } from '../selectors/pageSection';
import { useApplicationContext } from '../utils/applicationContext';
import { isRemovePopularExperimentEnabled } from '../utils/isRemovePopularExperimentEnabled';

/**
 * @todo Удалить после завершения эксперимента
 * @description Данный функционал появился в задаче CD-253017, будет удалён в задаче CD-253242
 */
export const useRemovePopularEnabled = () => {
  const { config } = useApplicationContext();
  const experiments = useSelector(selectExperiments);
  const section = useSelector(selectPageSection);

  return isRemovePopularExperimentEnabled({ experiments, section, config });
};
